export const initialState = {
  colorScheme: {}
};
